import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultEventScheduleDisplayText = {
    eventScheduleWithSameStartAndEndDateFormat: '${startDate|d|D MMMM YYYY}',
    eventScheduleWithDifferentStartAndEndMonthFormat: '${startDate|d|D MMM} - ${endDate|d|D MMM YYYY}',
    eventScheduleWithSameStartAndEndMonthFormat: '${startDate|d|D} - ${endDate|d|D MMMM YYYY}',
    eventScheduleWithOnlyEndDateFormat: 'Ends ${endDate|d|D MMMM YYYY}',
    eventScheduleWithOnlyStartDateFormat: '${startDate|d|D MMMM YYYY}'
};
export const eventScheduleDisplayTextValidatorSchema = {
    eventScheduleWithSameStartAndEndDateFormat: nonEmptyStringValidator,
    eventScheduleWithDifferentStartAndEndMonthFormat: nonEmptyStringValidator,
    eventScheduleWithSameStartAndEndMonthFormat: nonEmptyStringValidator,
    eventScheduleWithOnlyEndDateFormat: nonEmptyStringValidator,
    eventScheduleWithOnlyStartDateFormat: nonEmptyStringValidator
};
export const eventScheduleDisplayTextValidator = Validator.object(eventScheduleDisplayTextValidatorSchema);
